import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-table-loading',
    templateUrl: './table-loading.component.html',
    styleUrls: ['./table-loading.component.scss'],
    standalone: false
})
export class TableLoadingComponent implements OnChanges {
    @Input() rows = 9;
    loadingArr = Array(this.rows);

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.rows) {
            this.loadingArr = Array(this.rows);
        }
    }
}
